export const trackPhoneCallClick = (name, extra = {}) => {
  return createActivity('Activity::PhoneCallClick', { name, ...extra });
};

export const createActivity = (type, extra, successCallback) => {
  return fetch(`/api/v1/activities`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      ...window.utmInfo,
      activity: {
        type: type,
        extra: extra,
      },
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      if (successCallback) {
        successCallback(data);
      }
      return data;
    })
    .catch((error) => {
      console.error('Error creating activity:', error);
    });
};
